import { generateCSV } from "./helpers";

export const generateCSVData = (
  boardCards,
  allCardsByBoard,
  workflowSteps,
  columns
) => {
  const allCards = boardCards.flatMap((boardCard) => {
    const subTasks = allCardsByBoard?.data?.data?.responseData?.filter(
      (card) => card.card.parent_card_id === boardCard.card.card_id
    );
    return [boardCard, ...subTasks];
  });

  const parentMap = new Map();
  const independentRows = [];

  allCards?.forEach((item) => {
    const { card } = item;

    const obj = {
      "Task Id": card?.card_id,
      "Parent Task ID": card?.parent_card_id,
      Status: workflowSteps?.find(
        (workflowStep) =>
          card?.workflow_step_id === workflowStep?.workflow_step_id
      )?.status,
      Label: item?.labels && item?.labels.join(", "),
      "Allocated Hours": card?.allocated_hours,
      Milestone: card?.epic?.epic_name,
      "Task Title": card?.title,
      Assignee:
        card?.assigned_to_user &&
        card?.assigned_to_user?.first_name +
          " " +
          card?.assigned_to_user?.last_name,
      "Hours Spent": item?.total_hours_spent,
      "Due Date":
        card?.due_date && new Date(card?.due_date).toLocaleDateString("en-GB"),
      "Created Date":
        card?.date_created &&
        new Date(card?.date_created).toLocaleDateString("en-GB"),
      Reporter:
        card?.reported_by &&
        card?.reported_by?.first_name + " " + card?.reported_by?.last_name,
      "Last Updated":
        card?.updated_at &&
        new Date(card?.updated_at).toLocaleDateString("en-GB"),
    };

    const hiddenLabels = columns
      .filter((column) => column.isHidden)
      .map((column) => {
        if (column?.id === "assigned_to_user_name") {
          return "Assignee";
        }
        if (column?.id === "col3") {
          return "Status";
        }
        if (column?.id === "col7") {
          return "Milestone";
        }
        return column.label;
      });

    hiddenLabels.forEach((label) => {
      if (obj.hasOwnProperty(label)) {
        delete obj[label];
      }
    });

    if (item?.card?.parent_card_id) {
      if (!parentMap.has(item?.card.parent_card_id)) {
        parentMap.set(item?.card.parent_card_id, []);
      }

      parentMap.get(item?.card?.parent_card_id).push(obj);
    } else {
      independentRows.push(obj);
    }
  });

  const orderedRows = [];

  independentRows.forEach((parent) => {
    orderedRows.push({
      "Task Id": parent["Task Id"],
      "Parent Task ID": " - ",
      ...parent,
    });

    if (parentMap.has(parent["Task Id"])) {
      parentMap.get(parent["Task Id"]).forEach((child) => {
        orderedRows.push({
          "Task Id": child["Task Id"],
          "Parent Task ID": child["Parent Task ID"],
          ...child,
          "Task Title": "  - " + child["Task Title"], // Indent subtasks (if any)
        });
      });
    }
  });

  generateCSV(orderedRows, "test");
};
